import {
} from 'js/helpers/reducers';

import {
  SET_REPORT_REQUEST_KEY,
  POSTED_REPORT_REQUEST,
  POST_REPORT_REQUEST,
} from 'components/Pages/Reports/actions.js';

const defaultState = {
  request: {
    name: 'test name',
    keyword_tags: [
      {
        value: 'Culture',
        num_contents: 1,
        pct_num_contents: 0.0117647058823529,
      },
      {
        value: 'Family',
        num_contents: 1,
        pct_num_contents: 0.0117647058823529,
      },
      {
        value: 'Podcast',
        num_contents: 1,
        pct_num_contents: 0.0117647058823529,
      },
      {
        value: 'Brand',
        num_contents: 1,
        pct_num_contents: 0.0117647058823529,
      },
      {
        value: 'Shopping',
        num_contents: 1,
        pct_num_contents: 0.0117647058823529,
      }, {
        value: 'Paradise',
        num_contents: 1,
        pct_num_contents: 0.0117647058823529,
      },
    ],
    brands: [
      {
        public_id: '00e4fa5a-d3eb-4fea-a35f-3ff7c60c9393',
        name: 'Bleacher Report',
        type: 'publisher',
        banner_image_url: null,
        logo_url: 'https://knotch-svc-feed-images-production.s3.amazonaws.com/publishers/2163/logo/' +
          'iG3bfMpHBgA1kzkPC3eekg.png',
        hero_image_url: null,
        is_subscribed: false,
        is_competitor: false,
        num_contents: 223,
        pct_num_contents: 0.00173108421763532,
        publish_date: '2019-04-09',
        total_results: 25,
        page_count: 1,
        current_page: 1,
      },
      {
        public_id: '01040528-a031-4a2d-ac86-f2e6732cc956',
        name: 'Complex',
        type: 'publisher',
        banner_image_url: 'https://knotch-svc-feed-images-production.s3.amazonaws.com/infinite/hero_images/' +
          'None_007ea4af00ab27595110be6a00526a36_202003042055.jpg',
        logo_url: 'https://knotch-svc-feed-images-production.s3.amazonaws.com/publishers/2640/logo/' +
          '2arKzfsrFev6RlWkdjqFdg.png',
        hero_image_url: 'https://knotch-svc-feed-images-production.s3.amazonaws.com/infinite/hero_images/' +
          'None_007ea4af00ab27595110be6a00526a36_202003042055.jpg',
        is_subscribed: false,
        is_competitor: false,
        num_contents: 761,
        pct_num_contents: 0.00590742192654924,
        publish_date: '2018-05-08',
        total_results: 25,
        page_count: 1,
        current_page: 1,
      },
    ],
    publishers: [
      {
        public_id: '8dd4ce02-ffb5-45f9-a6c8-2b2e7d783b8d',
        name: 'Buzzfeed',
        type: 'publisher',
        banner_image_url: 'https://knotch-svc-feed-images-production.s3.amazonaws.com/infinite/hero_images/' +
          'None_000cdd6e2eb70139a3622c094eb1cf7f_202003042142.jpg',
        logo_url: 'https://knotch-svc-feed-images-production.s3.amazonaws.com/publisher/7/logo/ysMN' +
          '9O-hKC9I_BxLyL-I_A.jpeg',
        hero_image_url: 'https://knotch-svc-feed-images-production.s3.amazonaws.com/infinite/hero_images/' +
          'None_000cdd6e2eb70139a3622c094eb1cf7f_202003042142.jpg',
        is_subscribed: false,
        is_competitor: false,
        num_contents: 5277,
        pct_num_contents: 0.0409638180110386,
        publish_date: '2017-11-22',
        total_results: 25,
        page_count: 1,
        current_page: 1,
      },
      {
        public_id: '9e22618d-ab14-4412-9d9a-a71ce4c9e239',
        name: 'Daily Express',
        type: 'publisher',
        banner_image_url: 'https://knotch-svc-feed-images-production.s3.amazonaws.com/infinite/hero_images/' +
          'None_0116ac979db48623cf0f98b0d9f3819e_202003042116.jpg',
        logo_url: 'https://knotch-svc-feed-images-production.s3.amazonaws.com/publishers/3635/logo/' +
          'xsqwCeg50W713h5mMN2wTQ.jpg',
        hero_image_url: 'https://knotch-svc-feed-images-production.s3.amazonaws.com/infinite/hero_images/' +
          'None_0116ac979db48623cf0f98b0d9f3819e_202003042116.jpg',
        is_subscribed: false,
        is_competitor: false,
        num_contents: 204,
        pct_num_contents: 0.001583592737209,
        publish_date: '2018-07-04',
        total_results: 25,
        page_count: 1,
        current_page: 1,
      },
      {
        public_id: 'b6e0ec46-ec0e-4037-9bdb-b527aa00e795',
        name: 'The Every Girl',
        type: 'publisher',
        banner_image_url: 'https://knotch-svc-feed-images-production.s3.amazonaws.com/infinite/hero_images/' +
          'None_01fcf069ab79bae1c279030aee0b08e2_202003042053.jpg',
        logo_url: 'https://knotch-svc-feed-images-production.s3.amazonaws.com/publishers/14248/logo' +
          '/18ac8E8kGCLYNbrvucuFqQ.png',
        hero_image_url: 'https://knotch-svc-feed-images-production.s3.amazonaws.com/infinite/hero_images/' +
          'None_01fcf069ab79bae1c279030aee0b08e2_202003042053.jpg',
        is_subscribed: false,
        is_competitor: false,
        num_contents: 213,
        pct_num_contents: 0.0016534571226741,
        publish_date: '2018-07-03',
        total_results: 25,
        page_count: 1,
        current_page: 1,
      },
      {
        public_id: 'c51a5a13-f233-4751-9d5c-3413b0e6d52c',
        name: 'Red Tricycle',
        type: 'publisher',
        banner_image_url: 'https://knotch-svc-feed-images-production.s3.amazonaws.com/infinite/hero_images/' +
          'None_084cbe5687c003ea4aa6e1c7885a18d3_202003042136.jpg',
        logo_url: 'https://knotch-svc-feed-images-production.s3.amazonaws.com/publishers/6907/logo/' +
          '5n3v63qxLVNU9Ks06zcivA.png',
        hero_image_url: 'https://knotch-svc-feed-images-production.s3.amazonaws.com/infinite/hero_images/' +
          'None_084cbe5687c003ea4aa6e1c7885a18d3_202003042136.jpg',
        is_subscribed: false,
        is_competitor: false,
        num_contents: 24,
        pct_num_contents: 0.000186305027906941,
        publish_date: '2018-01-18',
        total_results: 25,
        page_count: 1,
        current_page: 1,
      },
      {
        public_id: 'e6088c6c-162a-452a-93ca-7c664cbb6344',
        name: 'POPSUGAR',
        type: 'publisher',
        banner_image_url: 'https://knotch-svc-feed-images-production.s3.amazonaws.com/infinite/hero_images/' +
          'None_0011acaff4ca4ee9c6b9eec049d8267a_202003042059.jpg',
        logo_url: 'https://knotch-svc-feed-images-production.s3.amazonaws.com/publisher/299/logo/MT' +
          'a0H1z7eSeQtEXavQM26A.jpeg',
        hero_image_url: 'https://knotch-svc-feed-images-production.s3.amazonaws.com/infinite/hero_images/' +
          'None_0011acaff4ca4ee9c6b9eec049d8267a_202003042059.jpg',
        is_subscribed: false,
        is_competitor: false,
        num_contents: 3543,
        pct_num_contents: 0.0275032797447621,
        publish_date: '2016-12-21',
        total_results: 25,
        page_count: 1,
        current_page: 1,
      },
      {
        public_id: 'f6bebb38-7c3a-440c-a42f-2230ce1bd90c',
        name: 'GQ',
        type: 'publisher',
        banner_image_url: 'https://knotch-svc-feed-images-production.s3.amazonaws.com/infinite/hero_images/' +
          'None_0074beb46b4914dcb3f024241a2e2d9d_202003042056.jpg',
        logo_url: 'https://knotch-svc-feed-images-production.s3.amazonaws.com/publisher/456/logo/99' +
          'OvSrIqAQOygz2y9SoP7A.jpeg',
        hero_image_url: 'https://knotch-svc-feed-images-production.s3.amazonaws.com/infinite/hero_images/' +
          'None_0074beb46b4914dcb3f024241a2e2d9d_202003042056.jpg',
        is_subscribed: false,
        is_competitor: false,
        num_contents: 533,
        pct_num_contents: 0.00413752416143331,
        publish_date: '2018-05-21',
        total_results: 25,
        page_count: 1,
        current_page: 1,
      },
    ],
  },
  posting: false,
  posted: false,
};

// eslint-disable-next-line complexity
const EntityProfileReducer = (state = defaultState, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return { ...defaultState };
    case SET_REPORT_REQUEST_KEY:
      return { ...state, request: { ...state.request, ...action.payload } };
    case POST_REPORT_REQUEST:
      return { ...state, posting: true, posted: false };
    case POSTED_REPORT_REQUEST:
      return { ...state, posting: false, posted: true };
    default:
      return Object.assign({}, state);
  }
};

export default EntityProfileReducer;
